//region :: Imports ::
import React, {Fragment, ReactElement} from 'react';
import MComponent from '../Component';
import {Divider} from 'primereact/divider';
import {isNullOrUndefined} from '../../Utils';

//endregion

/** */
export type MPropertyListRTProps = {
    items: MPropertyListItem[];
}

/** */
export type MPropertyListItem = {
    label: string;
    value: any;
}

/** */
export type Props = MPropertyListRTProps & {
    header: string;
}

/** */
export type State = {
    hoverElementId?: string;
}

/** */
class MPropertyList extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);

    }

    /** */
    private initializeState(): void {
        this.state = {hoverElementId: undefined};
    }

    /** */
    private static async copyIcon_onClick(text?: string): Promise<void> {
        await navigator.clipboard.writeText(text === undefined ? '' : text!);
    }

    /** */
    private onMouseEnter(elementId?: string): void {

        this.safeSetState((draft: State) =>
            draft.hoverElementId = elementId);

    }

    /** */
    private onMouseLeave(): void {

        this.safeSetState((draft: State) =>
            draft.hoverElementId = undefined);

    }

    /** */
    public render(): ReactElement {

        return (
            <Fragment>
                <div className="text-2xl uppercase font-light mb-3">{this.props.header}</div>
                {
                    this.props.items.map((item: MPropertyListItem, index: number) => {

                        const key = `mpropertylist-${index}-${item.label}`;
                        const hasValue = !isNullOrUndefined(item.value);
                        const value = hasValue ? item.value : '-';
                        const showCopyIcon = hasValue && key === this.state.hoverElementId;
                        const dividerElement = index >= this.props.items.length ? null :
                                               (
                                                   <div className="px-2">
                                                       <Divider align="center"
                                                                type="dashed"
                                                                style={{marginBottom: '0.8rem', marginTop: '0.8rem'}}/>
                                                   </div>
                                               );

                        return (
                            <Fragment key={key}>
                                <div className="font-medium mb-1 m-text-wrap uppercase mtext-wrap">{item.label}</div>
                                <div className="flex justify-content-between align-items-center"
                                     onMouseEnter={() => this.onMouseEnter(key)}
                                     onMouseLeave={() => this.onMouseLeave()}>

                                    <div id={key} className="font-normal m-text-wrap flex-grow-1">{value}</div>
                                    <i className="text-lg pi pi-copy cursor-pointer"
                                       style={{display: showCopyIcon ? 'inherit' : 'none'}}
                                       onClick={async() => await MPropertyList.copyIcon_onClick(value)}/>

                                </div>
                                {dividerElement}
                            </Fragment>
                        );

                    })
                }
            </Fragment>
        );

    }

}

export default MPropertyList;
